import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=b15aa04a"
import script from "./WithdrawalList.vue?vue&type=script&lang=js"
export * from "./WithdrawalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports